import { ListItem, ListItemButton, ListItemIcon, ListItemText, Tooltip } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import { ReactNode } from "react";

export interface DrawerNavMenuItemProps {
  icon: ReactNode;
  label: string;
  tooltip: string;
  path: string;
  collapsed?: boolean;
}

/**
 * Navigation menu item component.
 *
 * Displays an icon, label, and tooltip. Highlights when the current route matches the path.
 */
export function DrawerNavMenuItem({
  icon,
  label,
  tooltip,
  path,
  collapsed = false,
}: DrawerNavMenuItemProps) {
  const location = useLocation();
  const isActive = location.pathname.startsWith(path);

  return (
    <ListItem disablePadding disableGutters sx={{ height: 48 }}>
      <Tooltip title={collapsed ? tooltip : ""} placement="right">
        <ListItemButton
          component={Link}
          to={path}
          selected={isActive}
          disableGutters
          sx={{
            borderRadius: 0.5,
            padding: 1,
            minWidth: 48,
          }}
        >
          <ListItemIcon
            sx={{
              minWidth: 24,
              marginRight: 1.5,
              justifyContent: "flex-start",
              color: isActive ? "primary.main" : "text.secondary",
            }}
          >
            {icon}
          </ListItemIcon>
          {!collapsed && (
            <ListItemText
              primary={label}
              sx={{
                "& span": {
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                },
              }}
            />
          )}
        </ListItemButton>
      </Tooltip>
    </ListItem>
  );
}
